<template>
  <v-container>
    <div class="formBox">
      <v-form ref="form" v-model="valid" lazy-validation>
        <!-- 發票號碼 -->
        <p class="title">發票號碼
          <span v-if="tab == 0" class="help" @click="seePopUp('Question')">
            <v-icon color="darken-2">mdi-help-circle</v-icon>什麼是隨機碼？
          </span>
        </p>
        <v-text-field v-model="form.inv_number" :rules="rules.inv_number" :counter="10" solo required
          label="AA12345678">
        </v-text-field>
        <!-- 隨機碼＆上傳發票明細 -->
        <div class="electronicBox" v-if="tab == 0">
          <v-select :items="items" :rules="[v => !!v || 'Item is required']" solo required v-model="select"></v-select>
          <v-text-field v-if="select =='隨機碼'" v-model="form.inv_randomNumber" :rules="rules.inv_randomNumber"
            :counter="4" solo required label="1234"></v-text-field>
          <v-file-input v-if="select =='上傳發票明細'" v-model="form.file_inv_photo" :rules="rules.file_inv_photo" required
            prepend-icon="mdi-camera" accept="image/png, image/jpeg, image/bmp" label="上傳發票明細" solo>
          </v-file-input>
        </div>
        <!-- 購買城市 -->
        <p class="title" v-if="tab == 1">購買城市</p>
        <v-select v-if="tab == 1" :items="buyCityItems" item-text="name" :rules="rules.buyCityItems" solo required
          v-model="form.buyCity">
        </v-select>

        <!-- 發票日期 -->
        <p class="title">發票日期</p>
        <v-text-field v-model="form.inv_date" type="date" :rules="rules.inv_date" solo required value="2018-07-22">
        </v-text-field>

        <!-- 購買品項 -->
        <p class="title">購買品項(可複選)</p>
        <div class="checkboxBox">
          <v-checkbox v-model="form.buyCategory" v-for="(n,index) in buyItem" :key="index" :label="`${n.text}`"
            :value="n.value" required :rules="rules.buyCategory"></v-checkbox>
        </div>

        <br><img :src="require(`../assets/img/from/line${tab}.png`)" width="100%"><br>

        <!-- 姓名 -->
        <p class="title">姓名</p>
        <v-text-field v-model="form.name" :rules="rules.name" solo required label="王小明">
        </v-text-field>

        <!-- 性別 -->
        <p class="title">性別</p>
        <v-radio-group v-model="form.gender" row>
          <v-radio v-for="n in genderItem" :key="n" :label="`${n}`" :value="n"></v-radio>
        </v-radio-group><br>

        <!-- 手機號碼 -->
        <p class="title">手機號碼</p>
        <v-text-field v-model="form.mobile" :rules="rules.mobile" :counter="10" solo required label="0912345678">
        </v-text-field>

        <!-- 電子信箱 -->
        <p class="title">電子信箱</p>
        <v-text-field v-model="form.email" :rules="rules.email" solo required label="xxxx@xx.xx.xxx">
        </v-text-field>

        <!-- 居住城市 -->
        <p class="title">居住城市</p>
        <v-select :items="liveCityItems" item-text="name" :rules="rules.liveCity" solo required v-model="form.liveCity">
        </v-select>

        <!-- 並同意個資 -->
        <v-checkbox v-model="checkbox" required :rules="[v => !!v || '請勾選個資同意']">
          <template v-slot:label>
            <div>
              我已經詳盡讀並同意
              <a target="_blank" href="https://vuetifyjs.com" @click="seePopUp('Information')">
                個資告知事項及注意事項
              </a>
            </div>
          </template>
        </v-checkbox>
        <img width="120" src="@/assets/img/from/decorateCat.png">
      </v-form><br>
      <v-btn :disabled="!valid" @click="validate()">
        <img src="@/assets/img/from/btnSubmit.png">
      </v-btn>
      <popup :popupIconType="popupIconType" :popupItem="popupItem" :prize="prize" v-if="dialog"
        @popupStatus="dialog=false" />
    </div>
  </v-container>
</template>

<script>
  // import axios from "axios";
  // import swal from 'sweetalert2'
  import popup from '../components/popup';

  export default {
    name: 'formBox',
    props: ['tab', ],
    components: {
      popup,
    },
    data: () => ({
      dialog: false,
      popupIconType: '',
      popupItem: '',
      prize: '',
      valid: true,
      tags: {
          'EpaperConfirm': '1379D54D0E214CC5ADC7B58A9E7A2058',
          'paperConfirm': '9BBC38DB80E44271AECD394CF9F8F0A3'
      },
      form: {
        inv_type: '',
        inv_number: '', //發票號碼
        inv_randomNumber: '', //隨機碼
        file_inv_photo: '', //上傳發票明細
        buyCity: '臺北市', //購買城市
        inv_date: '', //發票日期
        buyCategory: [], //購買品項
        name: '',
        gender: '男',
        mobile: '',
        email: '',
        liveCity: '臺北市', //居住城市
        gCAPTCHA_token: '',
      },
      rules: {
        inv_number: [v => !!v || '請輸入發票號碼', v => /^[A-Z]{2}[0-9]{8}$/.test(v) || '格式錯誤'],
        inv_randomNumber: [v => (!!v && v.length == 4) || '請輸入四位隨機碼', ],
        file_inv_photo: [v => !!v || '請上傳發票明細'],
        buyCityItems: [v => !!v || '請選擇購買城市'],
        inv_date: [v => (!!v) || '請選擇發票日期'],
        buyCategory: [v => (!!v && v.length > 0) || '請選擇至少一個購買品項', ],
        name: [v => (!!v) || '請輸入姓名'],
        mobile: [v => !!v || '請輸入十位手機號碼', v => /^[0-9]{10}$/.test(v) || '格式錯誤'],
        email: [v => !!v || '請輸入電子信箱', v => /.+@.+\..+/.test(v) || '格式錯誤'],
        cityItems: [v => !!v || '請選擇居住城市']
      },
      select: '隨機碼',
      items: ['隨機碼', '上傳發票明細', ],
      buyItem: [{
          "text": "春風抽取式/捲筒式衛生紙",
          "value": "春風抽取式和捲筒式"
        },
        {
          "text": "春風1秒抽廚紙/春風捲筒廚紙",
          "value": "春風1秒抽和捲筒廚紙"
        },
        {
          "text": "HELLO KITTY 全系列商品",
          "value": "HELLOKITTY全系列"
        },
        {
          "text": "寶島春風 系列",
          "value": "寶島春風"
        },
        {
          "text": "Andante 洗沐系列",
          "value": "Andante洗沐"
        },
        {
          "text": "其他春風商品",
          "value": "其他春風"
        }
      ],
      genderItem: ['男', '女', ],
      checkbox: '',
      buyCityItems: ['基隆市', '台北市', '新北市', '桃園市', '新竹縣', '新竹市', '苗栗縣', '台中市', '彰化縣', '南投縣', '雲林縣', '嘉義縣', '嘉義市',
        '台南市', '高雄市', '屏東縣', '宜蘭縣', '花蓮縣', '臺東縣', '澎湖縣', '金門縣', '連江縣',
      ],
      liveCityItems: ['基隆市', '台北市', '新北市', '桃園市', '新竹縣', '新竹市', '苗栗縣', '台中市', '彰化縣', '南投縣', '雲林縣', '嘉義縣', '嘉義市',
        '台南市', '高雄市', '屏東縣', '宜蘭縣', '花蓮縣', '臺東縣', '澎湖縣', '金門縣', '連江縣',
      ],
    }),
    mounted() {},
    methods: {
      seePopUp(val) {
        this.dialog = true
        this.popupIconType = 'icon' + val
        this.popupItem = val
      },
      // 驗證表單
      validate() {
        this.$refs.form.validate();
        if (this.$refs.form.validate()) {
          this.$addTags(this.tab == 0 ? this.tags.EpaperConfirm : this.tags.paperConfirm, null, null, null);
          this.ParentData()
        }
      },
      ParentData() {
        this.$emit("getParentData", this.form)
      }


    },
  }
</script>
<style lang="scss">
  #app {
    .day {
      .v-text-field {
        padding: 0;
        margin: 0;
      }
    }
  }

  .formBox {

    .v-form {
      padding: 20px 20px 0 20px;
      background: #EBD559;
      display: flex;
      flex-direction: column;
      border-radius: 0 0 12px 12px;

      >img {
        // width: 120px;
        margin: 0 auto;
      }

      .help {
        width: 68%;
        display: inline-block;
        text-align: right;
        color: #C35238;
        font-size: 15px;

        .v-icon.v-icon {
          margin-right: 5px;
          font-size: 20px;
          color: #C35238;
        }
      }

      .title {
        position: relative;
        padding-left: 30px;
        margin-bottom: 5px;

        &::before {
          content: '';
          display: block;
          width: 18px;
          height: 18px;
          position: absolute;
          left: 0;
          top: 5px;
          background-repeat: no-repeat;
          // background-image: url(../assets/img/from/Vector.png);
        }
      }

      .v-input--selection-controls {
        margin: 0;
        padding: 0;
      }

      .v-input__control {
        .v-messages {
          min-height: 0;

          &.error--text {
            margin-bottom: 12px;
          }
        }
      }
    }

    .v-input--checkbox.error--text:not(:last-child) .v-input__slot+.error--text {
      display: none;
    }
  }
</style>